/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Custom_Domain_ConnectionInputs */

const en_pricing_feature_custom_domain_connection = /** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Domain Connection`)
};

const es_pricing_feature_custom_domain_connection = /** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexión de Dominio Personalizado`)
};

const fr_pricing_feature_custom_domain_connection = /** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion de domaine personnalisé`)
};

const de_pricing_feature_custom_domain_connection = /** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Domain-Verbindung`)
};

const id_pricing_feature_custom_domain_connection = /** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koneksi Domain Kustom`)
};

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const ja_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const zh_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const ar_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const it_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const ru_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const pt_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/** @type {(inputs: Pricing_Feature_Custom_Domain_ConnectionInputs) => LocalizedString} */
const ko_pricing_feature_custom_domain_connection = en_pricing_feature_custom_domain_connection;

/**
* | output |
* | --- |
* | "Custom Domain Connection" |
*
* @param {Pricing_Feature_Custom_Domain_ConnectionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_custom_domain_connection = /** @type {((inputs?: Pricing_Feature_Custom_Domain_ConnectionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Custom_Domain_ConnectionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_custom_domain_connection(inputs)
	if (locale === "es") return es_pricing_feature_custom_domain_connection(inputs)
	if (locale === "fr") return fr_pricing_feature_custom_domain_connection(inputs)
	if (locale === "de") return de_pricing_feature_custom_domain_connection(inputs)
	if (locale === "ja") return ja_pricing_feature_custom_domain_connection(inputs)
	if (locale === "zh") return zh_pricing_feature_custom_domain_connection(inputs)
	if (locale === "ar") return ar_pricing_feature_custom_domain_connection(inputs)
	if (locale === "id") return id_pricing_feature_custom_domain_connection(inputs)
	if (locale === "it") return it_pricing_feature_custom_domain_connection(inputs)
	if (locale === "ru") return ru_pricing_feature_custom_domain_connection(inputs)
	if (locale === "pt") return pt_pricing_feature_custom_domain_connection(inputs)
	return ko_pricing_feature_custom_domain_connection(inputs)
});